import { createStore, createStoreClass } from "../lib/store"
import state from "./state"
import actions from "./actions"

export const ProfileStore = createStoreClass(state, actions)

export default createStore(state, actions)


// WEBPACK FOOTER //
// ./src/store/index.js